import React, { useState } from 'react';
import { Container, CssBaseline, Grid, Box, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Firebase } from '@platform/core';
import Hero from '../static/images/HeroTheme.png';
import { Alert, AlertTitle } from '@material-ui/lab';
import { ThemeProvider } from '@material-ui/core/styles';
import { theme } from './components/theme';

const useStyles = makeStyles((t) => ({
  root: {
    display: 'flex',
    backgroundColor: t.palette.grey[100],
  },
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  container: {
    paddingTop: t.spacing(4),
    paddingBottom: t.spacing(4),
    minHeight: `100%`,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    backgroundColor: t.palette.grey[100],
  },
}));

export default function PwdExpiredPage() {

  const [isProcessing, setIsProcessing] = useState(false);
  const user = Firebase.getCurrentUser();
  const email = user?.email;

  const resetPassword = async (email) => {
      try {
        setIsProcessing(true);
        await Firebase.resetPassword(email);
      } catch (e) {
        window.alert('Failed to send password reset email.');
      } finally {
        setIsProcessing(false);
      }
    };

  const content = (
    <div style={{ justifyContent: 'center' }}>
      <Box>
        <Alert severity='error'>
          <AlertTitle>Your password has expired</AlertTitle>
          For security purposes, passwords must be updated every 180 days.
        </Alert>
      </Box>
      {email && (
        <div style={{ marginTop: 24, marginBottom:'24px', color: theme.palette.text.secondary, textAlign: 'center' }}>
          Signed in as <strong>{email}</strong>
        </div>
      )}
      <div style={{ display: 'flex', gap: '12px', marginTop:'12px', marginBottom:'12px', }}>
        <Button 
          fullWidth
          variant='contained' 
          color='primary' 
          onClick={() => resetPassword(email)} 
          disabled={isProcessing}
        >
          Update Password
        </Button>
      </div>
      <div style={{ display: 'flex', gap: '12px', marginTop:'12px', marginBottom:'12px', }}>
        <Button 
          fullWidth
          variant='outlined' 
          onClick={() => Firebase.signOut()}
        >
          Use Another Account
        </Button>
      </div>
    </div>
  );


  const classes = useStyles();
  return (
    <ThemeProvider theme={theme}>
      <div className={classes.root}>
        <CssBaseline />
        <main className={classes.content}>
          <Container maxWidth='lg' className={classes.container}>
            <Grid container justifyContent='center' alignItems='center'>
              <Grid item xs={12} sm={4}>
                <Box
                  display='flex'
                  flexDirection='column'
                  alignItems='center'
                  justifyContent='center'
                >
                  <img src={Hero} alt='Vysioneer' style={{ width: '100%' }} />
                  <div style={{ width: '80%', height: '60px' }}>
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                      {content}
                    </div>
                  </div>
                </Box>
              </Grid>
            </Grid>
          </Container>
        </main>
      </div>
    </ThemeProvider>
  );
}